<div class="flex-1 min-h-0 overflow-auto px-[1.25rem] pb-[0.5rem]"
     [formGroup]="form">
  <p class="text-[0.75rem] leading-[150%] text-(--p-gray-500)"
     translate="@@fp-event-create__description"></p>

  <div class="mt-[1.25rem] flex flex-col gap-[0.375rem]">
    <span class="text-[0.75rem] font-semibold leading-[150%] text-(--p-blue-300)"
          translate="@@fp-event-field__location"></span>

    <gc-dialog-event-location-card [showShare]="false"></gc-dialog-event-location-card>
  </div>

  <div class="mt-[1.25rem] flex flex-col gap-[0.375rem]">
    <label class="text-[0.75rem] font-semibold leading-[150%] text-(--p-blue-300)"
           for="dialog-event-create-comment"
           translate="@@shared-comment-label"></label>

    <textarea id="dialog-event-create-comment"
              pTextarea
              class="h-[8.9375rem] w-full resize-none !text-[0.75rem] !font-medium placeholder:!text-(--p-gray-300)"
              formControlName="comment"
              [placeholder]="'@@fp-event-create__comment-placeholder' | translate"></textarea>

    @if (form.controls.comment.hasError('maxlength')) {
      <span class="text-[0.75rem] font-medium leading-[150%] text-(--p-red-500)"
            translate="@@edit-comment-characters-error"
            [translateParams]="{ I18N_VAR_MAX: maxCommentLength }"></span>
    } @else {
      <span class="text-[0.75rem] font-medium leading-[150%] text-(--p-gray-500)"
            translate="@@edit-comment-characters"
            [translateParams]="{ I18N_VAR_CURRENT: form.controls.comment.value.length, I18N_VAR_MAX: maxCommentLength }"></span>
    }
  </div>
</div>

<div class="flex shrink-0 items-center justify-end gap-[0.25rem] border-t border-t-(--p-primary-50) px-[1.25rem] py-[0.875rem]">
  <p-button [outlined]="true"
            styleClass="!h-[2rem] !p-[0.375rem_1rem_0.5rem_1rem] !rounded-[0.25rem] max-md:!h-[2.5rem] max-md:!px-[1.4375rem]"
            [label]="'@@shared-cancel__text' | translate"
            [disabled]="dialogState.isSaving()"
            (onClick)="cancelled.emit()"></p-button>

  <p-button styleClass="!h-[2rem] !p-[0.375rem_1rem_0.5rem_1rem] !rounded-[0.25rem] max-md:!h-[2.5rem] max-md:!px-[1.4375rem]"
            [label]="'@@shared-create-event__text' | translate"
            [loading]="dialogState.isSaving()"
            [disabled]="form.invalid"
            (onClick)="create()"></p-button>
</div>
